import { InjectionToken } from "@angular/core";

export const SW_CORE_GUARD = new InjectionToken<string>("CORE_GUARD");
